import React from 'react'

import {
  ConfluenceGreyIcon,
  GoogleDocsIcon,
  GuruIcon,
  NotionIcon,
  SlabIcon,
} from '@slite/icons'

export const getIconFromCompetitor = (competitorName: string) => {
  switch (competitorName) {
    case 'Guru':
      return GuruIcon
    case 'Confluence':
      return ConfluenceGreyIcon
    case 'Google Docs':
      return GoogleDocsIcon
    case 'Slab':
      return SlabIcon
    default:
      return NotionIcon
  }
}
